import { useTranslation } from 'react-i18next';

import { useRoutes } from '../../../navigation';

import { EditIcon } from '@wonderschool/common-base-ui';
type SummaryViewTitleProps = {
  title?: string;
  hash?: string;
  showEditIcon?: boolean;
};
export default function SummaryViewTitle({ title, showEditIcon = true }: SummaryViewTitleProps) {
  const { t } = useTranslation();
  const { goBack } = useRoutes();

  if (!title) return null; // an empty title means no title

  return (
    <h2 data-testid="summary-view-wrapper">
      {t(title ?? 'enrollments.scheduleFormTitle')}
      {showEditIcon && (
        <button
          type="button"
          aria-label={t('common.edit')}
          className="edit cursor-pointer border-0 bg-transparent p-0"
          onClick={() => goBack()}
          data-testid="summary-view-btn"
        >
          <EditIcon className="size-5" />
        </button>
      )}
    </h2>
  );
}
